let lectors;

export default lectors = [
  {
    name: "Robert Kotuliak",
    id: "1",
    role: "Head of Academy & Testing",
    description: `Robo pôsobil ako SW Quality & Test Specialist na IT&Network oddelení telekomunikačnej spoločnosti. Má dlhoročné skúsenosti z pôsobenia v domácich ako aj v zahraničných korporáciách. Pôsobil ako developer, projektový manažér a ostatných viac ako 10 rokov pracuje v oblasti testingu. Vďaka pôsobeniu na “všetkých stranách barikády” sa snaží skĺbiť to najlepšie z testingu s potrebami projektu a možnosťami vývoja.`,
    highlight: "Vzdelávanie s Robom je nielen efektívne, ale aj zábavné!",
  },
  {
    name: "Beáta Maláková",
    id: "2",
    role: "odborná školiteľka",
    description: `Beáta pôsobí v IT viac ako 20 rokov, v bankách, telekomunikačných spoločnostiach, v automotive prostredí, ako aj verejnej sfére. Prešla si rôznymi testerskými pozíciami na IT projektoch v domácom a zahraničnom prostredí, aj v multikultúrnych tímoch. Ostatných 20 rokov zastrešovala testovanie na pozícii test manažéra. O získané vedomosti a skúsenosti sa s Vami prostredníctvom školenia rada podelí.`,
    highlight:
      "Beátin individuálny prístup je podporený veľkou ochotou a úsmevom.",
  },
  {
    name: "Martin Kozlovský",
    id: "3",
    role: "odborný školiteľ",
    description: `Martin Kozlovský, pôsobí v IT viac ako 15 rokov. V testingu prešiel rôznymi pozíciami od manuálneho testera, test manažéra, test analytika, performance testera, manažéra testerského tímu o veľkosti 50 testerov. V agilnom prostredí prešiel projektami z viacerých odvetví, ako medicína, telekomunikácie či bankovníctvo. Má viac ako 10 ročné skúsenosti s agilným svetom, na pozícii, testera, test manažéra, Scrum mastra, aj agilného coacha. Je držiteľom ISTQB – Full Advanced certifikácie.`,
    highlight:
      "Školenie s Martinom ti prinesie podrobné informácie o preberanej látke a množstvo zaujímavých cvičení.",
  },
  {
    name: "Tal Pe’er",
    id: "4",
    role: "odborný školiteľ",
    description: `Tal sa venuje testovaniu softvéru od roku 1996, kedy pracoval ako tester a test manažér na mnohých rôznorodých projektoch v oblastiach ako komunikácia, overovanie online médií, petrochémia a obrana. V súčasnosti je Tal nezávislý konzultant a školiteľ v oblasti zlepšovania softvérových a testovacích procesov. Keď práve netestuje, rád sa venuje fotografovaniu a hraniu na gitaru.`,
    highlight:
      "",
  },
  {
    name: "Tomáš Pekarovič",
    id: "6",
    role: "odborný školiteľ",
    description: `Tomáš pôsobí v testingu a test automatizácií uz takmer 20 rokov. Na pár rokov si odskočil do developmentu ale vždy sa s radosťou vrátil k testingu. Posledných pár rokov okrem testovania aj vyvíja automatizačné riešenia pre firmy a navrhuje a pripravuje CI/CD pipeline. Zároveň je aj držiteľom viacerých ISTQB certifikátov, niektorí ho dokonca nazývajú ich zberateľom.`,
    highlight:
      "Tomáš je vyhľadávaný školiteľ s množstvom osobných profesionálnych skúseností, ktoré dokáže zrozumiteľným spôsobom odovzdávať ďalej",
  },
  {
    name: "Rebecca Lužová",
    id: "7",
    role: "odborná školiteľka",
    description: `Rebecca Lužová má 6 rokov skúseností v IT a ako IT recruiter sa špecializuje na hiring softvérových testerov. V AAS Academy pomáha stážistom zorientovať sa na trhu práce, pochopiť očakávania zamestnávateľov a nájsť si prvú rolu v testovaní. Zároveň sa venuje employer ambassadoringu, vďaka čomu prepája kandidátov s firmami a pomáha budovať silné tímy.`,
    highlight:
        "",
  },
  {
    name: "Štefan Aitner",
    id: "8",
    role: "odborný školiteľ",
    description: `Štefan Aitner je skúsený odborník v oblasti náboru a HR s viac ako 15-ročnou praxou v spoločnostiach ako AAS Solutions, Mazars, NN Životná poisťovňa, ZUNO Bank či Accenture. Počas svojej kariéry viedol stovky pracovných pohovorov, spolupracoval s top manažmentom a pomáhal kandidátom uspieť na trhu práce.
                  Teraz svoje skúsenosti odovzdáva ďalej ako školiteľ pre uchádzačov o zamestnanie. Pomáha ľuďom pochopiť, ako sa pripraviť na pracovný pohovor, správne komunikovať so zamestnávateľom a zvýšiť svoje šance na úspech.`,
    highlight:
        "",
  },
  {
    name: "Radek Kitner",
    id: "9",
    role: "odborný školiteľ",
    description: `Radek Kitner je skúsený odborník na testovanie softvéru, kvalitu vývoja a automatizáciu testov. V IT pôsobí viac ako 30 rokov a pracoval na projektoch pre významné medzinárodné spoločnosti. Venuje sa zvyšovaniu kvality softvéru, zavádzaniu efektívneho testovania, mentoringu a vzdelávaniu začiatočníkov i profesionálov.<br />
                  Radek má vyše 10 rokov praxe v odovzdávaní svojich skúseností. Jeho kurzy sú založené na reálnych projektoch z praxe a kladú dôraz na zručnosti, ktoré je možné okamžite využiť v práci. Účastníci oceňujú zrozumiteľný výklad, praktické cvičenia a interaktívny štýl výučby, vďaka ktorému dokážu témy rýchlo pochopiť a používať.<br />
                  Radek pomohol stovkám ľudí vstúpiť do sveta IT a úspešne naštartovať kariéru v oblasti testovania, programovania a automatizácie. Jeho školenia využívajú aj firemné tímy, ktoré potrebujú zlepšiť procesy testovania, zaviesť automatizáciu alebo rozvíjať schopnosti svojich testerov.
                  Je lídrom komunity QA Brno – aktívne prepája odborníkov, zdieľa know-how a podporuje rast QA komunity v Českej republike.`,
    highlight:
        "",
  },
];
